// AGE-T brand + content assets (client-supplied CDN URLs)
const CDN = "https://customer-assets-agu9un31.emergentagent.net/job_age-t-modern/artifacts";
const CDN2 = "https://customer-assets-39nsmqrw.emergentagent.net/job_5f26dcc4-3c31-43f2-8068-643c69bf03b7/artifacts";

export const assets = {
  logo: `${CDN2}/mh0d2ihn_AGE-T%20Logo.png`,
  logoWhite: `${CDN2}/qifsueco_AGE-T%20Logo%20white.png`,
  mission: `${CDN2}/y3zarkir_age-t-icon-mission.png`,
  services: {
    tax: `${CDN}/pk2yzpgu_age-t-icon-tax-planning-compliance.png`,
    compilation: `${CDN}/ifep4r04_age-t-icon-compilation-financial-statements.png`,
    cfo: `${CDN}/kw18vl2a_age-t-icon-part-time-cfo.png`,
    cashflow: `${CDN}/n5qng658_age-t-icon-cash-flow-management.png`,
    newbusiness: `${CDN}/b0pzqf4a_age-t-icon-new-business-formation.png`,
    bank: `${CDN}/w8frgnmn_age-t-icon-bank-financing.png`,
  },
  company: {
    apa: `${CDN}/i9lbe0np_age-t-icon-aruba-ports-authority.png`,
    kpmg: `${CDN}/7sa5n9ng_age-t-icon-kpmg.png`,
    ey: `${CDN}/os5eextw_age-t-icon-ernst-young.png`,
  },
  trainings: `${CDN}/8zzozj00_age-t-icon-trainings-courses-seminars-workshops.png`,
  // Editorial photography — hands writing over financial notes, laptops in scene (depth)
  heroBg: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400",
};

export const CONTACT = {
  phone: "2975920019",
  phoneDisplay: "+297 592 0019",
  email: "info@age-t.com",
  address: "Opal 52, Noord, Aruba",
  hours: "8am – 12pm  |  1pm – 5pm",
  social: {
    facebook: "https://facebook.com/AGETAruba",
    instagram: "https://instagram.com/agetaruba",
    linkedin: "https://linkedin.com/in/age-t-management-consulting-045323201/",
  },
};
